<app-nav-bar></app-nav-bar>
<div class="viewer-container" id="view-container" (mousemove)="onMouseMove()">
    <div *ngIf="boardUser">
        <!-- LEGACY LAYOUT: Single-channel viewer (when isLegacyMode = true) -->
        <div *ngIf="isLegacyMode" class="legacy-layout-container">
            <!-- Available Table -->
            <div class="legacy-column">
                <table class="table-up-board">
                    <thead>
                        <th>Available</th>
                    </thead>
                    <tr *ngFor="let item of legacyInState('up')">
                        <td class="col-primary">
                            <app-up-board-employee 
                                [emp]="normalizedToEmployee(item.emp)" 
                                [index]="item.index" 
                                [up]="item.emp === legacyUp" 
                                [onDeck]="item.emp === legacyOnDeck">
                            </app-up-board-employee>
                        </td>
                    </tr>
                </table>
            </div>
            
            <!-- Appointment Table -->
            <div class="legacy-column">
                <table class="table-up-board">
                    <thead>
                        <th>Appointment</th>
                    </thead>
                    <tr *ngFor="let item of legacyInState('with_apt')">
                        <td class="col-primary">
                            <app-up-board-employee 
                                [emp]="normalizedToEmployee(item.emp)" 
                                [index]="item.index">
                            </app-up-board-employee>
                        </td>
                    </tr>
                </table>
            </div>
            
            <!-- With Guest Table -->
            <div class="legacy-column">
                <table class="table-up-board">
                    <thead>
                        <th>With Guest</th>
                    </thead>
                    <tr *ngFor="let item of legacyInState('with_guest')">
                        <td class="col-primary">
                            <app-up-board-employee 
                                [emp]="normalizedToEmployee(item.emp)">
                            </app-up-board-employee>
                        </td>
                    </tr>
                </table>
            </div>
            
            <!-- Finance/Delivery + Break Stacked Column -->
            <div class="legacy-column legacy-stacked-column">
                <table *ngIf="showDelivery" class="table-up-board">
                    <thead>
                        <th>Finance/Delivery</th>
                    </thead>
                    <tr *ngFor="let item of legacyInStates(['delivery', 'with_guest_delivery', 'with_apt_delivery'])">
                        <td class="col-alternate">
                            <app-up-board-employee 
                                [emp]="normalizedToEmployee(item.emp)" 
                                [index]="item.index">
                            </app-up-board-employee>
                        </td>
                    </tr>
                </table>
                <table [ngClass]="{'mt-2': showDelivery}" class="table-up-board">
                    <thead>
                        <th>Break</th>
                    </thead>
                    <tr *ngFor="let item of legacyInState('break')">
                        <td class="col-alternate">
                            <app-up-board-employee 
                                [emp]="normalizedToEmployee(item.emp)" 
                                [index]="item.index">
                            </app-up-board-employee>
                        </td>
                    </tr>
                </table>
            </div>
            
            <!-- Deliveries Stacked Column (shown when delivery feature is enabled) -->
            <div *ngIf="showDelivery" class="legacy-column legacy-stacked-column">
                <table class="table-up-board">
                    <thead>
                        <th class="delivery">Deliveries (In Store)</th>
                    </thead>
                    <tr *ngFor="let delivery of inStore(deliveries, true)">
                        <td [ngClass]="{
                            'col-primary': true,
                            'delivery': true,
                            'bg-success': timeUtils.isOnSchedule(delivery, now),
                            'bg-warning': timeUtils.isWarning(delivery, now),
                            'bg-danger': timeUtils.isAlert(delivery, now)
                        }">
                            <div class="border border-3">
                                <div>[{{ delivery.stock_number }}] {{ delivery.vehicle?.year }} {{ delivery.vehicle?.model }} {{ delivery.vehicle?.color }}</div>
                                <div>{{ delivery.emp }} ({{ timeUtils.inStoreForStr(delivery.arrival_time, now) }})</div>
                            </div>
                        </td>
                    </tr>
                </table>
                <table class="table-up-board mt-2">
                    <thead>
                        <th class="delivery">Deliveries Priority 2</th>
                    </thead>
                    <tr *ngFor="let delivery of inStore(deliveries, false)">
                        <td [ngClass]="{
                            'col-primary': true,
                            'delivery': true,
                            'bg-success': timeUtils.isOnSchedule(delivery, now),
                            'bg-warning': timeUtils.isWarning(delivery, now),
                            'bg-danger': timeUtils.isAlert(delivery, now)
                        }">
                            <div class="border border-3">
                                <div class="w-100">[{{ delivery.stock_number }}] {{ delivery.vehicle?.year }} {{ delivery.vehicle?.model }} {{ delivery.vehicle?.color }}</div>
                                <div class="w-100">{{ delivery.emp }} (
                                    <span *ngIf="delivery.arrival_time > now">in </span>
                                    {{ timeUtils.arrivingInStr(delivery.arrival_time, now) }}
                                    <span *ngIf="delivery.arrival_time <= now">late</span>)
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>

        <!-- MODERN LAYOUT: Multi-Column Card-Based UI (when !isLegacyMode) -->
        <ng-container *ngIf="!isLegacyMode">
        <!-- Multi-Column Layout: All Enabled Channels Shown Simultaneously -->
        <div class="board-multi-column-wrapper">
            <div class="row">
                    <!-- Floor Ups Column (Instore) - Always visible if instore enabled -->
                    <div class="col-channel" *ngIf="enabledChannels.includes('instore')">
                        <div class="col-channel-content">
                            <div class="channel-header">
                                <h5 class="channel-title">Available for Walk-ins</h5>
                            </div>
                           <div class="employee-list drop-zone">
                                <div *ngFor="let emp of floorUpsEmployees" class="employee-card">
                                    <div class="card-content">
                        <app-up-board-employee 
                            [editMode]="false"
                            [emp]="normalizedToEmployee(emp)"
                            [normalized]="emp"
                            [channel]="'instore'"
                            [showDelivery]="showDelivery"
                            [unavailable]="isEmployeeUnavailable(emp, 'instore')"
                            [up]="emp.email === instoreUp?.email"
                            [onDeck]="emp.email === instoreOnDeck?.email">
                        </app-up-board-employee>
                                    </div>
                                </div>
                              <div *ngIf="floorUpsEmployees.length === 0" class="empty-state">
                                  <p class="text-muted">No employees</p>
                              </div>
                          </div>
                        </div>
                    </div>
                
                    <!-- With Guest Column (Instore) - Always visible if instore enabled -->
                    <div class="col-channel" *ngIf="enabledChannels.includes('instore')">
                        <div class="col-channel-content">
                            <div class="channel-header">
                                <h5 class="channel-title">With Guest</h5>
                            </div>
                           <div class="employee-list drop-zone">
                                <div *ngFor="let emp of withGuestEmployees" class="employee-card">
                                    <div class="card-content">
                                        <app-up-board-employee 
                                            [editMode]="false"
                                            [emp]="normalizedToEmployee(emp)"
                                            [normalized]="emp"
                                            [channel]="'instore'"
                                            [showDelivery]="showDelivery"
                                            [unavailable]="false"
                                            [up]="emp.email === instoreUp?.email"
                                            [onDeck]="emp.email === instoreOnDeck?.email">
                                        </app-up-board-employee>
                                    </div>
                                </div>
                              <div *ngIf="withGuestEmployees.length === 0" class="empty-state">
                                  <p class="text-muted">No employees</p>
                              </div>
                          </div>
                        </div>
                    </div>
                
                    <!-- Phone Ups Column - Visible if phone channel enabled -->
                    <div class="col-channel" *ngIf="enabledChannels.includes('phone')">
                        <div class="col-channel-content">
                            <div class="channel-header">
                                <h5 class="channel-title">Phone</h5>
                            </div>
                           <div class="employee-list drop-zone">
                                <div *ngFor="let emp of phoneUpsEmployees" class="employee-card">
                                    <div class="card-content">
                        <app-up-board-employee 
                            [editMode]="false"
                            [emp]="normalizedToEmployee(emp)"
                            [normalized]="emp"
                            [channel]="'phone'"
                            [showDelivery]="showDelivery"
                            [unavailable]="isEmployeeUnavailable(emp, 'phone')"
                            [up]="emp.email === phoneUp?.email"
                            [onDeck]="emp.email === phoneOnDeck?.email"
                            [isUpInInstore]="emp.email === instoreUp?.email"
                            [isOnDeckInInstore]="emp.email === instoreOnDeck?.email">
                        </app-up-board-employee>
                                    </div>
                                </div>
                              <div *ngIf="phoneUpsEmployees.length === 0" class="empty-state">
                                  <p class="text-muted">No employees</p>
                              </div>
                          </div>
                        </div>
                    </div>
                
                    <!-- Internet Ups Column - Visible if online channel enabled -->
                    <div class="col-channel" *ngIf="enabledChannels.includes('online')">
                        <div class="col-channel-content">
                            <div class="channel-header">
                                <h5 class="channel-title">Internet</h5>
                            </div>
                           <div class="employee-list drop-zone">
                                <div *ngFor="let emp of internetUpsEmployees" class="employee-card">
                                    <div class="card-content">
                        <app-up-board-employee 
                            [editMode]="false"
                            [emp]="normalizedToEmployee(emp)"
                            [normalized]="emp"
                            [channel]="'online'"
                            [showDelivery]="showDelivery"
                            [unavailable]="isEmployeeUnavailable(emp, 'online')"
                            [up]="emp.email === onlineUp?.email"
                            [onDeck]="emp.email === onlineOnDeck?.email"
                            [isUpInInstore]="emp.email === instoreUp?.email"
                            [isOnDeckInInstore]="emp.email === instoreOnDeck?.email">
                        </app-up-board-employee>
                                    </div>
                                </div>
                              <div *ngIf="internetUpsEmployees.length === 0" class="empty-state">
                                  <p class="text-muted">No employees</p>
                              </div>
                          </div>
                        </div>
                    </div>

                  <!-- Deliveries Column - Visible if showDelivery is true -->
                   <div class="col-channel col-delivery" *ngIf="showDelivery">
                       <div class="col-channel-content">
                         <!-- Deliveries (In Store) Section -->
                         <div class="channel-header">
                             <h5 class="channel-title">Deliveries - In Store</h5>
                         </div>
                     <div class="employee-list drop-zone">
                         <div *ngFor="let delivery of inStore(deliveries, true)" class="delivery-card">
                             <div class="card-content">
                                 <div [ngClass]="{
                                     'delivery-status': true,
                                     'bg-success': timeUtils.isOnSchedule(delivery, now),
                                     'bg-warning': timeUtils.isWarning(delivery, now),
                                     'bg-danger': timeUtils.isAlert(delivery, now)
                                 }">
                                     <div class="delivery-info">
                                         <div>[{{ delivery.stock_number }}] {{ delivery.vehicle?.year }} {{ delivery.vehicle?.model }} {{ delivery.vehicle?.color }}</div>
                                         <div>{{ delivery.emp }} ({{ timeUtils.inStoreForStr(delivery.arrival_time, now) }})</div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <div *ngIf="inStore(deliveries, true).length === 0" class="empty-state">
                             <p class="text-muted">No deliveries</p>
                         </div>
                     </div>

                         <!-- Deliveries Priority 2 Section (Customer Not In Store) -->
                         <div class="channel-header delivery-priority-2">
                             <h5 class="channel-title">Deliveries - Priority 2</h5>
                         </div>
                     <div class="employee-list drop-zone">
                         <div *ngFor="let delivery of inStore(deliveries, false)" class="delivery-card">
                             <div class="card-content">
                                 <div [ngClass]="{
                                     'delivery-status': true,
                                     'bg-success': timeUtils.isOnSchedule(delivery, now),
                                     'bg-warning': timeUtils.isWarning(delivery, now),
                                     'bg-danger': timeUtils.isAlert(delivery, now)
                                 }">
                                     <div class="delivery-info">
                                         <div>[{{ delivery.stock_number }}] {{ delivery.vehicle?.year }} {{ delivery.vehicle?.model }} {{ delivery.vehicle?.color }}</div>
                                         <div>{{ delivery.emp }} ({{ timeUtils.inStoreForStr(delivery.arrival_time, now) }})</div>
                                     </div>
                                 </div>
                             </div>
                         </div>
                         <div *ngIf="inStore(deliveries, false).length === 0" class="empty-state">
                             <p class="text-muted">No deliveries</p>
                         </div>
                     </div>
                       </div>
                 </div>
            </div>
        </div>
        </ng-container>

        <!-- Company Logo - Fixed bottom right -->
        <div *ngIf="board?.logoUrl" class="logo-fixed-bottom-right">
            <img [src]="board?.logoUrl" alt="Company Logo" class="company-logo" />
        </div>

        <div class="fixed-bottom">
            <button id="btnToggle" class="btn btn-large btn-dark float-right m-3 shadow-sm" style="opacity: 0%;" (click)="toggleFullscreen()">
                <fa-icon [icon]="icons.faExpand"></fa-icon>
            </button>
        </div>

    </div>
    <div class="text-dark" *ngIf="loaded && !boardUser">
        <h1>Sorry you do not have rights to view this board.</h1>
    </div>
</div>
